
import { useCallback, useEffect, useRef, useState } from 'react'

import loadingImg from '@/assets/images/cards/loading.png'
import { useNavigate } from 'react-router-dom'
import Back from '../../components/common/BackComp.js';
import { getCurrentAvatarLanguage, getCharacterInfo } from "@/api/url.js"
import { getCharacterChatList, delCharacterChatList, pinCharacterChatList } from '../../api/avatar.js'
import { List, SwipeCell, Toast } from 'react-vant'
import moment from "moment"
import PromptDialog from '../../components/PromptDialog.js';
import { pushChatListId, setCurrAvatarId, setCurrCharacterInfo } from '../../store/module/progress.js';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

const Battle = () => {
        const { t } = useTranslation();
    const [isShowMenuList, setShowMenuList] = useState(false)

    const [dataList, setDataList] = useState<any>([])
    const currPage = useRef(1)
    const total = useRef(0);
    const pageSize = 20
    const [finished, setFinished] = useState(false);
    const isInitLoading = useRef(true)
    const [isLoading, setIsLoading] = useState(false)
    const clickHandle = (e: Event) => {
        e.stopPropagation();
        if (isShowMenuList) {
            setShowMenuList(false)
        }
    }

    const pinHandle = async (item: any) => {
        const toast = Toast.loading({
            message:t("other.loading"),
            forbidClick: true,
            duration: 0
        })
        try {
            const params = {
                id: item.session_id,
                is_pin: !item.is_pin
            }
            const { code } = await pinCharacterChatList(params)
            if (code == "0") {
                currPage.current = 1
                setDataList([])
                toast.clear()

                await getCharacterChatListHandle()
            }

        } catch (e) {
            toast.clear()
        }

    }

    const delHandle = async (id: string) => {
        const toast = Toast.loading({
            message: t("other.loading"),
            forbidClick: true,
            duration: 0
        })
        try {
            const { code } = await delCharacterChatList(id)
            if (code == "0") {
                currPage.current = 1
                setDataList([])
                toast.clear()

                await getCharacterChatListHandle()
            }

        } catch (e) {
            toast.clear()
        }

    }

    useEffect(() => {
        document.addEventListener("click", clickHandle)
        return () => {
            document.removeEventListener("click", clickHandle)
        }
    }, [isShowMenuList])

    const navigate = useNavigate();
    const boxRef = useRef<any>(null)
    const [dialog, setDialog] = useState(false)


    useEffect(() => {
        // isInitLoading.current = true;
        // setFinished(true)
        currPage.current = 1
        setDataList([])
        getCharacterChatListHandle()
    }, [])

    const onLoad = async () => {
        if (finished || isInitLoading.current) return;
        currPage.current++
        await getCharacterChatListHandle();

    }


    // //获取记录
    const getCharacterChatListHandle = useCallback(async () => {
        setIsLoading(true)
        try {
            const params = {
                limit: pageSize,
                page: currPage.current,
                id: localStorage.getItem('userId')
            }
            const { code, data } = await getCharacterChatList(params)

            if (code == "0") {
                setIsLoading(false)
                total.current = data?.count
                isInitLoading.current = false
                setFinished(false)
                if (data?.chatted) {
                    setDataList((prevData: any) => [...prevData, ...data.chatted]);
                }
            } else {
                setFinished(true)
                total.current = 0
            }
        } catch (e) {
            console.log("��� ~ getCharacterChatListHandle ~ e:", e)
            setFinished(true)
            setIsLoading(false)
            total.current = 0
        }

        if (currPage.current * pageSize >= total.current) {
            setFinished(true)
            return false;
        }



    }, [])

    const dispatch = useDispatch()
    const [ids, setIds] = useState<any>([])
    const chatMessageList = useSelector((state: any) => state.progress.chatList)


    useEffect(() => {
        const ids: any = dataList.length && dataList.map((item: any) => item.character_id)
        setIds(ids)
        const listId = chatMessageList.map((item: any) => item.id)
        for (let i = 0; i < ids.length; i++) {
            if (!listId.includes(ids[i])) {
                dispatch(pushChatListId({ id: ids[i], list: [], actionList: [] }))
            }
        }

    }, [dataList])



    //更新数据
    const dataUpHandle = async (id: string) => {
        const toast = Toast.loading({
            message: t("other.loading"),
            forbidClick: true,
            duration: 0
        })
        try {

            const { code, data } = await getCharacterInfo(id);
            if (code == "0") {
                dispatch(setCurrCharacterInfo(data))
                window.localStorage.setItem("currCharacterInfo", JSON.stringify(data));
                dispatch(setCurrAvatarId(id))

            }
            toast.clear()
        } catch (e) {
            toast.clear()
        }

    }
    //go to talk page logic handler
    const goToTalkPage = async (currCharacterInfo: any) => {
        if (!chatMessageList.length) {
            for (let i = 0; i < ids.length; i++) {
                dispatch(pushChatListId({ id: ids[i], list: [], actionList: [] }))
            }
        }
        await dataUpHandle(currCharacterInfo.character_id)
        const language = await getCurrentLanguage(currCharacterInfo.character_id)
        //跳转到聊天页
        setTimeout(() => {
            navigate(`/agent?id=${currCharacterInfo.character_id}&language=${language}&key=record`);
        }, 200);

    }
    //get current avatar language
    const getCurrentLanguage = async (id: string) => {
        try {
            const { code, data } = await getCurrentAvatarLanguage(id)
            if (code == 0) {
                return data
            }
        } catch (e) {
            console.log("🚀 ~ getCurrentLanguage ~ e:", e)
        }
    }

    return (
        <div ref={boxRef} className="descriptionLogs w-full h-full text-white pt-12 px-4 box-border relative pb-[30px] overflow-x-hidden overflow-y-scroll">
            <div className="h-11 flex items-center justify-center md:absolute max-md:fixed top-0 w-[calc(100%_-_32px)] z-[11] box-border bg-[#071919]">
                <Back isLeft={false} callback={() => { navigate("/agents") }}>
                    <div className='w-[90%] h-10 text-white flex justify-around items-center'>
                        {t("agent.records.messages")}
                    </div>
                </Back>
            </div>
            <List className='list w-full grid grid-cols-1 gap-0' finished={finished} loading={isLoading} immediateCheck={false} onLoad={onLoad} loadingText={t("other.loading")}>
 
                {
                    dataList && dataList?.length > 0 && dataList.map((item: any) => {
                        return (
                            <SwipeCell
                                rightAction={
                                    <div className='grid grid-cols-2 gap-0 w-[180px] h-[60px]'>
                                        <div onClick={async () => {
                                            await pinHandle(item)
                                        }} className='h-full bg-[#54ADFF] text-[#fff] text-sm flex flex-col justify-center items-center'>
                                            <svg width="22px" height="22px" viewBox="0 0 22 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                                                <g id="页面-2" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                                    <g id="最近聊过-消息置顶" transform="translate(-208.000000, -167.000000)">
                                                        <g id="编组-2备份" transform="translate(208.000000, 167.000000)">
                                                            <rect id="矩形" fillOpacity="0" fill="#D8D8D8" x="0" y="0" width="22" height="22"></rect>
                                                            <g id="编组" transform="translate(2.000000, 2.000000)" fill="#FFFFFF" fillRule="nonzero">
                                                                <path d="M17.8081607,0.853757484 C17.8081607,1.32527472 17.3214358,1.70751497 16.7210302,1.70751497 L1.10510103,1.70751497 C0.504695432,1.70751497 0.0179705293,1.32527472 0.0179705293,0.853757484 C0.0179705293,0.382240245 0.504695432,0 1.10510103,0 L16.7210302,0 C17.3214358,0 17.8081607,0.382240245 17.8081607,0.853757484 Z M9.00010977,4.02880886 C8.39970418,4.02880886 7.91297927,4.41104911 7.91297927,4.88256635 L7.91297927,17.1462425 C7.91297927,17.6177598 8.39970418,18 9.00010977,18 C9.60051537,18 10.0872403,17.6177598 10.0872403,17.1462425 L10.0872403,4.88256635 C10.0872403,4.41104911 9.60051537,4.02880886 9.00010977,4.02880886 Z M9.77183315,3.39894558 C9.3470576,3.06567778 8.68306418,3.04637655 8.28901009,3.3561612 L0.280536712,9.64482173 C-0.113926992,9.95460638 -0.0893498137,10.4760611 0.335016123,10.8093289 C0.759791679,11.1429184 1.42337548,11.161898 1.81783918,10.8521133 L9.82590295,4.56345277 C10.219957,4.25366813 10.1957895,3.73221339 9.77142353,3.39894558 L9.77183315,3.39894558 Z M8.22879601,3.39894558 C7.80443007,3.73221339 7.77985289,4.25366813 8.1743166,4.56345277 L16.1823804,10.852435 C16.5764344,11.161898 17.2404279,11.1429184 17.6652034,10.8093289 C18.0895694,10.4760611 18.1137369,9.95460638 17.7192732,9.64482173 L9.71161907,3.3561612 C9.31715537,3.04637655 8.65316195,3.06567778 8.22879601,3.39894558 Z" id="形状"></path>
                                                            </g>
                                                        </g>
                                                    </g>
                                                </g>
                                            </svg>
                                            {
                                                item.is_pin ? t("agent.records.unpin_chat") : t("agent.records.pin_chat")
                                            }</div>
                                        <div onClick={async () => {
                                            await delHandle(item.session_id)
                                        }} className='h-full bg-[#00E49F] text-[#fff] text-sm flex flex-col justify-center items-center'>
                                            <svg width="22px" height="22px" viewBox="0 0 22 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                                                <g id="页面-2" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                                    <g id="最近聊过-消息置顶" transform="translate(-312.000000, -167.000000)">
                                                        <g id="编组-3备份" transform="translate(312.000000, 167.000000)">
                                                            <rect id="矩形" fillOpacity="0" fill="#D8D8D8" x="0" y="0" width="22" height="22"></rect>
                                                            <g id="编组备份-5" transform="translate(2.000000, 2.000000)" fill="#FFFFFF" fillRule="nonzero">
                                                                <path d="M13.7791044,2.56332794 C14.6726,2.68017279 15.6023591,2.52978636 16.3319412,2.64510432 C17.5134708,2.83186086 18.1123586,3.76536819 17.9825533,5.13959692 C17.5057116,5.13959692 17.0289238,5.13959692 16.5520013,5.13959692 C16.5116964,7.57739423 16.5300707,9.99316422 16.5300707,12.4390716 C16.5300707,13.6736021 16.6407204,14.9719368 16.5080862,16.0785587 C16.3825916,17.1247808 15.5577706,17.7619457 14.5493954,17.9187902 C13.5550839,18.0734319 12.2356126,17.9596909 11.1382759,17.9596909 C8.83723647,17.9596909 6.50559127,18.0010922 4.2499487,17.9596909 C3.15145349,17.9394908 2.34215081,17.6155893 1.85113777,16.9986494 C1.36007084,16.3817596 1.41099071,15.4482022 1.41099071,14.3406291 C1.41099071,11.2549536 1.41099071,8.19521019 1.41099071,5.13959692 C0.95613347,5.13959692 0.501303136,5.13959692 0.046499787,5.13959692 C-0.175069012,3.87520437 0.414092774,2.96657788 1.41099071,2.66555469 C2.14377887,2.44423031 3.12071298,2.62300192 4.16187621,2.56332794 C4.07781801,1.20236567 4.15697282,0.168533947 5.41633712,0.027934634 C5.97917684,-0.0349182925 6.73079726,0.027934634 7.4189699,0.027934634 C8.65979827,0.027934634 10.0977054,0.027934634 11.4243702,0.027934634 C12.1880605,0.027934634 12.9695862,-0.0405502774 13.3610226,0.273288808 C13.9031172,0.708027807 13.7611881,1.70941928 13.7791044,2.56332794 Z M5.52628628,1.37740767 C5.52628628,1.78633965 5.52628628,2.19527164 5.52628628,2.60420362 C7.82239534,2.60420362 10.1185044,2.60420362 12.4145865,2.60420362 C12.4145865,2.17482127 12.4145865,1.74543895 12.4145865,1.31608165 C10.1258595,1.31608165 7.8370247,1.31608165 5.54827073,1.31608165 C5.52262221,1.3195109 5.52437344,1.34839671 5.52628628,1.37740767 Z M4.1838337,5.28272437 C4.1838337,7.87038247 4.1838337,10.4472272 4.1838337,13.0729074 C4.1838337,13.7383574 4.01916583,15.1561652 4.44791654,15.4447229 C4.61848464,15.5595403 5.05828147,15.5764863 5.26220344,15.4447229 C5.70579905,15.1582678 5.54829769,13.78081 5.54829769,13.0933577 C5.54829769,10.4339107 5.54829769,7.73931996 5.54829769,5.2213733 C5.10084941,5.2213733 4.65332033,5.2213733 4.20584511,5.2213733 C4.18019657,5.22480255 4.18192083,5.25368838 4.1838337,5.28272437 Z M8.27719871,5.28272437 C8.27719871,7.6122124 8.27719871,10.3323848 8.27719871,12.8275532 C8.27719871,13.4228162 8.12834566,14.8318381 8.38722875,15.2402694 C8.55828179,15.510104 9.13394578,15.6324306 9.42157569,15.4243226 C9.81161114,15.1421227 9.64168963,13.6498977 9.64168963,13.0320567 C9.64168963,10.3658763 9.64168963,7.80838059 9.64168963,5.22142335 C9.19421442,5.22142335 8.74665838,5.22142335 8.29921009,5.22142335 C8.27356158,5.22480255 8.2753128,5.25368838 8.27719871,5.28272437 Z M12.4145865,5.28272437 C12.4145865,7.78990771 12.4145865,10.5807177 12.4145865,13.1751592 C12.4145865,13.9834613 12.2449883,15.2232483 12.8107108,15.4447229 C13.0570391,15.5411925 13.4941956,15.466575 13.6029594,15.3834219 C13.9723035,15.1009217 13.8010888,13.5863439 13.8010888,12.991156 C13.8010888,10.3384173 13.8010888,7.79446334 13.8010888,5.22142337 C13.3462316,5.22142337 12.8913743,5.22142337 12.4365979,5.22142337 C12.4109494,5.22480255 12.4127006,5.25368838 12.4145865,5.28272437 Z" id="形状"></path>
                                                            </g>
                                                        </g>
                                                    </g>
                                                </g>
                                            </svg>
                                            {t("agent.records.delete_chat")}
                                        </div>

                                    </div>
                                }
                            >
                                <div className='flex h-[60px] relative items-center' onClick={() => {
                                    goToTalkPage(item)
                                }}>
                                    <div className='w-[42px] h-[42px] mr-2 flex justify-center items-center'>
                                        <img className="w-[42px] h-[42px] rounded-full" src={item.image_url}></img>
                                    </div>
                                    <div className='h-[40px] flex-1 flex flex-col items-start justify-between overflow-hidden'>
                                        <div className='h-[40px] px-2 overflow-hidden w-full'>
                                            <div className='flex w-full justify-between'>
                                                <p className='text-base text-[#fff]'>{item.character_name}</p>
                                                <p className='text-xs text-[#a6a6a6]'>{moment(item.creat_at).format('YYYY-MM-DD HH:mm:ss')}</p>
                                            </div>
                                            <p className='text-[14px] w-full text-[#a6a6a6] truncate'>
                                                {item.last_msg}
                                            </p>
                                        </div>

                                    </div>
                                    <div className='absolute left-0 bottom-0 h-[1px] w-full bg-[#333]'></div>
                                </div>
                            </SwipeCell>
                        )
                    })

                }
                {
                    !isLoading && dataList && !dataList?.length &&
                    <div className={'w-[100%] h-[calc(100vh_-_120px)] py-4 flex flex-col items-center'}>
                        <img className="w-[225px] mt-10" src={loadingImg}></img>
                        <p className='text-[14px] text-[#FFF] mt-[25px] leading-[18px] font-bold'>{t("agent.records.no_chat_record")}</p>

                    </div>

                }

            </List>

            <PromptDialog title={t("other.attention")} dialog={dialog} setDialog={setDialog} callback={() => { setDialog(false) }} text={""}></PromptDialog>



        </div >
    )
}


export default Battle;